import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { replaceHashValues } from "utils/replaceHashValues";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import { checkNestedObject } from "utils/checkNestedObject";
import { affidavitConsent } from "../actions";
import { setA11yContent } from "../../NavigationHelper/actions";

import Header from "common-components/Header";
import Container from "common-components/Container";
import StyledLink from "common-components/StyledLink";
import Button from "common-components/Buttons";
import RectangleLoader from "common-components/RectangleLoader";

class AffidavitConfirmation extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Affidavit confirmation", this.props.pageContent.sc_pagetitle);
    }
  }

  handleAffidavitConsent = () => {
    this.props.affidavitConsent().then(() => {
      if (!this.props.error) {
        this.props.history.push({
          pathname:
            this.props.location.state && this.props.location.state.fromTokenizedLink
              ? "/privacy/your-data/guest-download/"
              : "/privacy/secure/download-status",
          state: { ...this.props.location.state }
        });
      }
    });
  };

  render() {
    if (this.props.loading) {
      return <RectangleLoader id={"AffdavitConfirmLoader"} />;
    }

    const { pageContent } = this.props;
    const { formattedAccountNumber, wlnAccountNumber } = window.reactGlobals;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }
    return (
      <Container>
        <Header style={{ maxWidth: "348px" }}>{convertStringToElements(pageContent.section_title)}</Header>
        <Div data-qm-encrypt="true">
          {convertStringToElements(
            replaceHashValues(pageContent.section_description, {
              selectedMDN: formatPhoneNumber(this.props.mtn) || formatPhoneNumber(this.props.mtnList[0]),
              accountNumber: formattedAccountNumber || wlnAccountNumber
            })
          )}
        </Div>
        {this.props.requestedChannel === "IVR" ? (
          <Button background={pageContent.buttons[0].type} onClick={this.handleAffidavitConsent}>
            {pageContent.buttons[0].text}
          </Button>
        ) : (
          <StyledLink
            background={pageContent.buttons[0].type}
            to={{
              pathname: "/privacy/secure/download-amount",
              state: { confirmAuth: true }
            }}
          >
            {pageContent.buttons[0].text}
          </StyledLink>
        )}
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent,
  selectedDevice: { mtn },
  downloadAndDelete: { requestedChannel, mtnList },
  loadingAndErrorState: { loading, error }
}) => ({
  pageContent: pageContent.affidavit_confirmation,
  requestedChannel,
  mtn,
  mtnList,
  loading,
  error
});

export default connect(
  mapStateToProps,
  { setA11yContent, affidavitConsent }
)(AffidavitConfirmation);

const Div = styled.div`
  max-width: 422px;
  margin-bottom: 56px;

  p {
    padding: 10px 0;
  }

  p:last-of-type {
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  }
`;
